import theme from '../Theme/Theme';

const styles = () => ({
  button: {
    boxSizing: 'border-box',
    width: '150px',
    minWidth: '150px',
    height: '50px',
    backgroundColor: theme.colors.primary,
    color: 'white',
    marginTop: '10px',
    [theme.screenSize.mobile]: {
      width: '100%',
      marginTop: '15px',
    },
  },
  sectionImg: {
    objectPosition: 'top',
    objectFit: 'cover',
    borderRadius: '24px',
    flex: 1,
  },
});

export default styles;
